import Mock from 'mockjs'

// 获取用户登录信息
export function getUserInfo() {
    return {
        isOpen: true,
        url: '/sso/userinfo',
        type: 'get',
        data: {
            "code": "1",
            "data": { "account": "supperadmin", "admin": false, "appAdmin": false, "appId": "1b4650a68377413eb83f32e3bf3cc983", "appInternalRoleIds": [], "attributes": { "lastLoginTime": "2021-02-18 14:11:37", "lastLoginIp": "183.129.186.86" }, "displayName": "supperadmin", "guest": false, "hrLevel": "EMPLOYEE", "internalRoleIds": [], "mainType": "ENT_LEGAL_USER", "mergeUserAssigness": ["A01", "supperadmin", "09545711d7c34b86820a7d1c595b1883", "role:b23566eada7b4914bdd990091d2d943a", "orgid:555D0000E20A4214B40955224065A901", "b23566eada7b4914bdd990091d2d943a", "555D0000E20A4214B40955224065A901"], "mobile": "45634545", "oldUserAssigness": ["supperadmin", "09545711d7c34b86820a7d1c595b1883", "b23566eada7b4914bdd990091d2d943a", "555D0000E20A4214B40955224065A901"], "orgAdmin": false, "orgId": "555D0000E20A4214B40955224065A901", "orgInfo": { "dataType": 0, "legalCode": "222222222222222222", "orgId": "555D0000E20A4214B40955224065A901", "orgName": "鹤壁公共资源交易平台", "orgType": "99", "regionCode": "410611" }, "orgInternalRoleIds": [], "roleCodes": [""], "roleIds": ["b23566eada7b4914bdd990091d2d943a"], "selectRoleCode": "ADMIN", "supperAdmin": true, "userAssigness": ["A01", "supperadmin", "09545711d7c34b86820a7d1c595b1883", "role:b23566eada7b4914bdd990091d2d943a", "orgid:555D0000E20A4214B40955224065A901"], "userAssignessOld": ["supperadmin", "09545711d7c34b86820a7d1c595b1883", "b23566eada7b4914bdd990091d2d943a", "555D0000E20A4214B40955224065A901"], "userId": "09545711d7c34b86820a7d1c595b1883", "userLevel": "NORMAL", "username": "supperadmin" },
            "msg": "操作成功！",
            "ssoServerUrl": "http://suite.ggzy.hebi.gov.cn/authorize/1b4650a68377413eb83f32e3bf3cc983/1?redirect_uri=http://zjcs.ggzy.hebi.gov.cn/api/oauth/tokenLogin"
        }
    }
}

// 获取基本信息
export function getSimpleInfo() {
    return {
        isOpen: true,
        url: '/sso/userinfo/simple',
        type: 'get',
        data: {
            "code": "1",
            "data": { "account": "supperadmin", "admin": false, "appAdmin": false, "appId": "1b4650a68377413eb83f32e3bf3cc983", "appInternalRoleIds": [], "attributes": { "lastLoginTime": "2021-02-18 14:11:37", "lastLoginIp": "183.129.186.86" }, "displayName": "supperadmin", "guest": false, "hrLevel": "EMPLOYEE", "internalRoleIds": [], "mainType": "ENT_LEGAL_USER", "mergeUserAssigness": ["A01", "supperadmin", "09545711d7c34b86820a7d1c595b1883", "role:b23566eada7b4914bdd990091d2d943a", "orgid:555D0000E20A4214B40955224065A901", "b23566eada7b4914bdd990091d2d943a", "555D0000E20A4214B40955224065A901"], "mobile": "45634545", "oldUserAssigness": ["supperadmin", "09545711d7c34b86820a7d1c595b1883", "b23566eada7b4914bdd990091d2d943a", "555D0000E20A4214B40955224065A901"], "orgAdmin": false, "orgId": "555D0000E20A4214B40955224065A901", "orgInfo": { "dataType": 0, "legalCode": "222222222222222222", "orgId": "555D0000E20A4214B40955224065A901", "orgName": "鹤壁公共资源交易平台", "orgType": "99", "regionCode": "410611" }, "orgInternalRoleIds": [], "roleCodes": [""], "roleIds": ["b23566eada7b4914bdd990091d2d943a"], "selectRoleCode": "ADMIN", "supperAdmin": true, "userAssigness": ["A01", "supperadmin", "09545711d7c34b86820a7d1c595b1883", "role:b23566eada7b4914bdd990091d2d943a", "orgid:555D0000E20A4214B40955224065A901"], "userAssignessOld": ["supperadmin", "09545711d7c34b86820a7d1c595b1883", "b23566eada7b4914bdd990091d2d943a", "555D0000E20A4214B40955224065A901"], "userId": "09545711d7c34b86820a7d1c595b1883", "userLevel": "NORMAL", "username": "supperadmin" },
            "msg": "操作成功！",
            "ssoServerUrl": "http://suite.ggzy.hebi.gov.cn/authorize/1b4650a68377413eb83f32e3bf3cc983/1?redirect_uri=http://zjcs.ggzy.hebi.gov.cn/api/oauth/tokenLogin"
        }
    }
}

// 登录
export function login() {
    return {
        isOpen: true,
        url: '/sso/oauth/adminLogin',
        type: 'post',
        data: {
            'msg': 'success',
            'code': '1',
            'data': '?',
            'expire': Mock.Random.natural(60 * 60 * 1, 60 * 60 * 12),
            'token': Mock.Random.string('abcdefghijklmnopqrstuvwxyz0123456789', 32)
        }
    }
}


// 登录
export function singlelogin() {
    return {
        isOpen: true,
        url: '/sso/login',
        type: 'post',
        data: {
            'msg': 'success',
            'code': '1',
            'data': '?',
            'expire': Mock.Random.natural(60 * 60 * 1, 60 * 60 * 12),
            'authCode': Mock.Random.string('abcdefghijklmnopqrstuvwxyz0123456789', 32)
        }
    }
}

// 登录
export function tokenlogin() {
    return {
        isOpen: true,
        url: '/tokenlogin',
        type: 'post',
        data: {
            'msg': 'success',
            'code': '1',
            'data': '/index?__vt_param__=abcd'
        }
    }
}

// 退出
export function logout() {
    return {
        isOpen: true,
        url: '/logout',
        type: 'post',
        data: {
            'msg': 'success',
            'code': '1'
        }
    }
}
